import {makeReducer, match} from 'web-app/util/redux';

import * as Actions from './actions';

export interface VoucherModalState {
    saving: boolean;
    deleting: boolean;
}

export default makeReducer<VoucherModalState>(
    [
        match(Actions.save, state => ({...state, saving: true})),
        match(Actions.saveSuccess, state => ({...state, saving: false})),
        match(Actions.saveFailed, state => ({...state, saving: false})),
        match(Actions.update, state => ({...state, saving: true})),
        match(Actions.updateSuccess, state => ({...state, saving: false})),
        match(Actions.updateFailed, state => ({...state, saving: false})),
        match(Actions.deleteVoucher, state => ({...state, deleting: true})),
        match(Actions.deleteVoucherSuccess, state => ({...state, deleting: false})),
        match(Actions.deleteVoucherFailed, state => ({...state, deleting: false})),
        match(Actions.deleteVoucherAborted, state => ({...state, deleting: false})),
    ],
    {
        saving: false,
        deleting: false,
    },
);
